var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 11,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#191F2E",
    d: "M10.876 1.08a.375.375 0 0 1 0 .53l-.782.782-1.5-1.5.782-.782a.375.375 0 0 1 .53 0zM9.564 2.922l-1.5-1.5-5.11 5.11a.4.4 0 0 0-.09.147l-.604 1.81a.187.187 0 0 0 .237.237l1.81-.603a.4.4 0 0 0 .147-.09z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#191F2E",
    fillRule: "evenodd",
    d: "M0 9.75c0 .621.504 1.125 1.125 1.125h8.25c.621 0 1.125-.504 1.125-1.125v-4.5a.375.375 0 0 0-.75 0v4.5a.375.375 0 0 1-.375.375h-8.25A.375.375 0 0 1 .75 9.75V1.5c0-.207.168-.375.375-.375H6a.375.375 0 1 0 0-.75H1.125C.504.375 0 .879 0 1.5z",
    clipRule: "evenodd"
  })));
};
export default SvgEdit;